import { Select } from 'antd';
import { useSuspenseQuery } from '@tanstack/react-query';
import { staffQueryOptions } from '../utils/queryOptions';
import { UserSwitchOutlined } from '@ant-design/icons';
import { HugeiconsIcon } from '@hugeicons/react';
import { User02Icon, UserMultiple02FreeIcons, UserMultipleFreeIcons } from '@hugeicons/core-free-icons';
import StaffMemberAvatar from '../microcomponents/StaffMemberAvatar';

interface SalesPointsSelectProps {
  setSelectedStaffMemberId: (value: string) => void;
  selectedStaffMemberId: string;
  size?: 'small' | 'middle' | 'large';
}

const StaffMemberSelect = ({
                             setSelectedStaffMemberId,
                             selectedStaffMemberId,
                             size = 'middle'
                           }: SalesPointsSelectProps) => {

  const staff = useSuspenseQuery(staffQueryOptions());

  let staffOptions = staff.data.map((member) => ({
    value: member.id,
    label: member.display_name
  }));

  staffOptions = [{ value: '', label: 'Tutto lo Staff' }, ...staffOptions];

  if (staffOptions.length === 1) {
    return <></>;
  }

  return (
    <Select prefix={selectedStaffMemberId && <StaffMemberAvatar className={'size-5'} id={selectedStaffMemberId} />}
            size={size}
            style={{ width: 200, flex: 1 }}
            placeholder={'Staff'}
            options={staffOptions}
            onSelect={setSelectedStaffMemberId}
            value={selectedStaffMemberId}
            optionRender={(oriOption) => <div className={'flex gap-2 items-center'}>
              {
                oriOption.value &&
                <StaffMemberAvatar className={'size-4'} id={oriOption.value as string} />
              }
              {oriOption.label}
            </div>}

    />);
};
export default StaffMemberSelect;
